// extracted by mini-css-extract-plugin
export default {"rewards":"Rewards_rewards__odAB5","title":"Rewards_title__Ku-Rx","list":"Rewards_list__lpJhq","item":"Rewards_item__XRzg7","status":"Rewards_status__exK6d"};